<template>
  <div class="home max">
    <div class="banner">
      <img
        class="banner_img"
        src="../../static/img/gsjs_banner.png"
        alt=""
      >
    </div>
    <div class="content w1200">
      <div class="con_left">
        <img src="../../static/img/gsjs_gsjs.png" alt="">
        <p v-for="(item,i) in gsList" :key="i" @mousemove="active = i" :class="{ active: active === i }">
          {{item.name}}
        </p>
      </div>
      <div class="con_right">
        <div class="jianjie info" v-if="active === 0">
          <div class="dimg">
            <img
              src="../../static/img/gsjs_ditu.png"
              alt=""
            >

          </div>
          <ul class="con">
            <li>
              <p>天津协和万邦保险经纪有限公司，成立于2008年，注册资本5000万，经营范围包括在全国区域内（港、澳、台除外）为投保人拟定投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；中国保监会批准的其他业务。</p>
              <div class="dimg">
                <img
                  src="../../static/img/gsjs_tu1.png"
                  alt=""
                >
              </div>
            </li>
            <li>
              <div class="dimg">
                <img
                  src="../../static/img/gsjs_tu2.png"
                  alt=""
                >
              </div>
              <p>成为全球领先的保险经纪公司</p>
            </li>
            <li>
              <p>诚信守法、团结进取、追求卓越、服务领先、创造价值、简单务实、不怕困难、积极进取、回馈社会、报效国家。</p>
              <div class="dimg">
                <img
                  src="../../static/img/gsjs_tu3.png"
                  alt=""
                ></div>
            </li>
            <li>
              <div class="dimg">
                <img
                  src="../../static/img/gsjs_tu4.png"
                  alt=""
                ></div>
              <p>本公司拥有一支高素质、高学历、高技能员工队伍。这是一支专业、敬业、爱岗的，充满活力与朝气，富于创新精神的团队。本公司多数员工具有金融、保险、保险经纪方面工作经验。同时，公司还聘请保险业内资深从业人员等在相关领域造诣深厚的专家组成顾问团队，以确保本公司为客户提供高标准、全方位的保险经纪服务。</p>
            </li>
            <li>
              <p>天津协和万邦保险经纪有限公司始终以“用心服务，尽善尽美。始于用户需求，终于用户满意，诚信为立足之本，创新为生存之源”，为客户提供优质高效的服务</p>
              <div class="dimg">
                <img
                  src="../../static/img/gsjs_tu5.png"
                  alt=""
                >
              </div>
            </li>
          </ul>
        </div>
        <div class="yinsi info" v-if="active === 1">
          <h4>隐私声明</h4>
          <p>欢迎访问天津协和万邦保险经纪有限公司网站。本声明将阐述我们关于隐私权保护的政策，您对天津协和万邦保险经纪有限公司网站的访问和使用，即表示您接受了本隐私声明，请仔细阅读我们的隐私政策和保密措施。
            <br>
            1、您提供的个人信息仅用于帮助您选择最合适的保险产品和保险公司及投保时使用。
            <br>
            2、本网站的用户在注册会员或投保时提供的个人资料，如：姓名、出生日期、电话、电子邮件、身份证号码、银行卡号、健康状况和病史资料等。我们不会向任何人出售、交换或透露您的个人信息。
            <br>
            3、我们不会向第三方透露您的个人信息，但以下情况除外：
            <br>
            （1）事先获得您的授权，您同意让第三方共享资料；<br>
            （2）只有提供个人相关资料，才能提供你所要求的产品和服务；<br>
            （3）根据有关的法律法规或相关政府主管部门要求；<br>
            （4）为免除您在生命、身体或财产方面之急迫危险；<br>
            （5）我们需要向代表我们提供产品或服务的保险公司提供资料（除非我们另行通知你，否则这些公司无权使用你的身份识别资料），如您通过本站购买保险产品，您的个人信息将会传递给您所选择的保险公司。<br>
            4、若有下列情况之一者，本网站将不承担任何法律责任：<br>
            （1）由于用户将个人密码告知他人或与他人共享注册账户，由此导致的任何个人资料泄露；<br>
            （2）任何由于黑客攻击、计算机病毒侵入或发作、政府管制等造成的暂时性关闭，使网络无法正常运行而造成的个人资料泄露、丢失、被盗用或被窜改等；<br>
            （3）由于与本网站链接的其它网站所造成之个人资料泄露及由此而导致的任何法律争议和后果，如果我们对该第三方的信息批露是被允许的；<br>
            （4）由于其他不可抗力因素而引起的任何后果。<br>
            若您对本隐私声明或天津协和万邦保险经纪有限公司网站的隐私保护措施以及您在使用中的问题有任何意见和建议请和我们客服联系：400-665-0265，我们欢迎您对这项声明给予评论并提出质疑。
            天津协和万邦保险经纪有限公司网站保留随时对本隐私权声明进行修改的权利，修订后的隐私权声明将会在本网站刊登，请随时登陆查阅。
          </p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      active: 0,
      gsList: [
        {
          name: "公司简介"
        },
        {
          name: "隐私声明"
        }
      ]
    };
  }
};
</script>

<style  lang="scss" scoped>
.content {
  background-color: #fff;
  padding: 60px 10px;
  display: flex;
  justify-content: space-between;
  .con_left {
    height: 460px;
    width: 223px;
    background-color: #5182c4;
    p {
      font-weight: 600;
      text-align: center;
      height: 60px;
      line-height: 60px;
      margin-top: 30px;
      color: #fff;
    }
    .active {
      background-color: #f4f4f4;
      color: #5583b5;
    }
  }
  .con_right {
    padding-left: 20px;
    .jianjie {
      position: relative;
      img {
        z-index: -1;
      }
      .con {
        position: absolute;
        top: 100px;
        height: 1000px;
        li {
          width: 800px;
          height: 220px;
          padding-left: 70px;
          margin-bottom: 80px;
          p {
            float: left;
            width: 370px;
          }
          .dimg {
            height: 180px;
            float: left;
            width: 280px;
            margin: 0 20px;
            overflow: hidden;
            img {
              display: block;
              margin: 0 auto;
              width: 100%;
              transition: all .7s;
            }
          }
            .dimg:hover{
              transition: all .8s;
              img{
                width: 120%;
              }
            }
        }
        li:nth-child(1) {
          padding-left: 100px;
        }
        li:nth-child(2) {
          padding-left: 160px;
          p {
            width: 280px;
            height: 220px;
            line-height: 200px;
            text-align: center;
          }
        }
        li:nth-child(4) {
          width: 770px;
          margin-left: 90px;
          p {
            width: 350px;
            position: relative;
            top: -30px;
          }
        }
        li:nth-child(5) {
          p {
            position: relative;
            top: 30px;
          }
        }
      }
    }
    .yinsi {
      padding: 0 20px;
      h4 {
        font-size: 30px;
        color: #323232;
        text-align: center;
        padding-bottom: 40px;
      }
      p {
        color: #5d5d5d;
        font-size: 24px;
        text-indent: 2em;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Introduction.vue